import React, {FC} from 'react';
//components
import BuyerObsFieldModal from '../ObservationFieldModal/BuyerObsFieldModal/BuyerObsFieldModal';
import SupplierObsFieldModal from './SupplierObsFieldModal/SupplierObsFieldModal';
import Text from '../../../../../../components/Text';
//assets

import '../ObservationFieldModal/styles.scss';

const ObservationFieldModal: FC<any> = ({handleCloseItemObsModal, setSupplierNote, item}: any) => {

  return (
    <div>
      <div className='modal-header'>
        <div className='modal-title-div'>
          <Text className='modal-title' size={16}>Observações da Cotação</Text>
        </div>
      </div>
      <div className='buyer-supplier-container'>
        <div>
          <div className='buyer-modal-div'>
            <Text className='buyer-modal-title' size={16}>Comprador</Text>
          </div>
          <hr />
          <BuyerObsFieldModal
            item={item}
          />
        </div>

        <div>
          <div className='supplier-modal-div'>
            <Text className='supplier-modal-title' size={16}>Fornecedor</Text>
          </div>
          <hr />
          <SupplierObsFieldModal 
            item={item}
            handleCloseItemObsModal={handleCloseItemObsModal}
            setSupplierNote={setSupplierNote}
            closeIcon={true}
          />
        </div>
      </div>
    </div>
  );
}

export default ObservationFieldModal;